import React, { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

import { ScrollNavMenuItemBlock as ScrollNavMenuItemBlockValue } from "@reactivated";

import { slugify } from "../../utils/text";
import { navMenuReady, onRegisterMenuItem } from "./hooks";

/**
 * Renders a navigation anchor target div with a unique ID (so that it can be linked to
 * via hash fragment). Upon rendering, the nav item registers itself with the
 * ScrollNavMenuBlock so that it appears in the nav bar.
 */
export const ScrollNavMenuItemBlock = (props: {
    value: ScrollNavMenuItemBlockValue;
    id?: string;
    index?: number;
}) => {
    const name = props.value.name || "";
    const elemID = slugify(name || props.id || uuidv4());

    // Wait for the nav menu to be ready to accept items, then register this
    // item with the menu.
    useEffect(() => {
        navMenuReady
            .wait()
            .then(() => {
                onRegisterMenuItem.emit({
                    elemID: elemID,
                    name: name,
                    sortOrder: props.index ?? 0,
                });
            })
            .catch(() => {
                console.error("navMenuReady timeout exceeded");
            });
    }, []);

    // Render the actual anchor target element which the menu will link to.
    return <div id={elemID} />;
};
